import { MenuEntry } from '@src/menu-entry';

export default MenuEntry.create()
    .setTitle('Versandverpackung')
    .setRoute('packaging_list')
    .setAdditionalRoutes([
        'packaging_edit',
        'packaging_create',
    ]);
